// extracted by mini-css-extract-plugin
export default {"success":"Info_success__7MZx8","icon":"Info_icon__zO-C0","info":"Info_info__bowGY","price":"Info_price__ttvti","text":"Info_text__ccEIy","button":"Info_button__GTihG"};